import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';


import React, { useContext } from 'react';
import { Link,useNavigate} from 'react-router-dom';

import { UserContext } from "../context/UserContext";
import Iconify from '../common/Iconify/Iconify';
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    
  },
  {
    label: 'Profile Manager',
    icon: 'eva:person-fill',
  },
  {
    label: 'Strategies : LISAs & LIRAs',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [login, setLogin] = useContext(UserContext);
  const [UserBio, setUserBio] = useState({});
  const navigate = useNavigate();
 
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    if (login.isLoggedIn) {
      // Set UserBio using context data
      const { email, ID_User, ID_Client, ID_Corp, Category, name } = login;
      setUserBio({ Email: email, Name: name, ID_User, ID_Client, ID_Corp, Category });
    }
  }, [login]);

  const handleLogout = () => {
    setLogin({ token: null, isLoggedIn: false });
    setUserBio({});
    navigate('/');
    handleClose();
    localStorage.removeItem('tkn_2050');
  };

  
  //const isLoggedIn = login.isLoggedIn;
    // Call the fetchUserData function when the component mounts or when the user logs in
    /*useEffect(() => {
        if (isLoggedIn) {
          fetchUserData();
        }
      }, [isLoggedIn]);
    */

    /*
      const handleLogout = () => {
        //setToken(null);
        setLogin({ token: null, isLoggedIn: false });
        setUserBio(""); //Clear user data
       
    
        // Navigate back to home page 
        navigate('/');
        handleClose();
    
         // Clear local storage
         localStorage.removeItem('tkn_2050');
    
      };
    */

  return (
    <>
 
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={''}
          alt={''}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
            <Iconify icon="mdi:user-details" />
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            minWidth: 200,
          },
        }}
      >

      {login.isLoggedIn ? (
        <Box sx={{ my: 1.5, px: 2 }}>
            {UserBio && (
        <>
                <Typography variant="subtitle2" noWrap>
                <div>Welcome, {UserBio.Name}</div>

                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                    {UserBio.Email}
                </Typography>
                </>
            )}
        </Box>

        ):(
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Link to="/login">
                  <button className="btnLIN" onClick={() => { handleClose()}}>Login</button></Link>
                <Link to="/sign-up" >
                  <button className="btnSUP" onClick={() => { handleClose()}}>Sign Up</button></Link>
            </div>
           )}

        <Divider sx={{ borderStyle: 'dashed' }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem 
            key={option.label} 
            onClick={() => {
                handleClose();
                if (option.label === 'Profile Manager') {
                  navigate('/UserProfile');
                }
                if (option.label === 'Home') {
                    navigate('/');
                  }
                if (option.label === 'Strategies : LISAs & LIRAs') {
                    navigate('/Strategies');
                  }
              }}
              disabled={!login.isLoggedIn && (option.label === 'Profile Manager' || option.label === 'Strategies : LISAs & LIRAs')}
            >
            {option.label}
          </MenuItem>
        ))}

        <Divider sx={{ borderStyle: 'dashed', m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={login.isLoggedIn ? handleLogout : null}
          sx={{ typography: 'body2', color: login.isLoggedIn ? 'error.main' : 'text.disabled', py: 1.5, cursor: login.isLoggedIn ? 'pointer' : 'not-allowed' }}
        >
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}